import Service from '../services/service';

export default class AccountProvider extends Service {
  save(account) {
    return this.persist({ json: account });
  }

  persist({ endpoint = '', json, method = 'put' }:any) {
    return new Promise((resolve, reject) => {
      const data = {
        _method: method,
        authenticity_token: this.csrfToken(),
      };

      if (json) {
        data['account'] = json;
      }

      $.ajax({
        url: `/my-account/${endpoint}`,
        type: 'POST',
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}